module.exports = __webpack_public_path__ + "static/product-collection-header-mobile-fd1d5b8e6e2755e41b9c38a7ee948144.svg";